// Hilfsfunktionen des Zahlungsschritts (Original `parseAmount` 2799–2808 und
// die Rechenteile aus `renderAdvanceBox` 2774–2799).

/**
 * Betrag aus einer Nutzereingabe lesen — deutsches (1.234,56) und einfaches
 * Format (1234.56). Negative Eingaben und Unsinn ergeben `null`, ebenso ein
 * leeres Feld: „kein Betrag" ist ein eigener Zustand und nicht 0 €.
 *
 * @param {string|number|null} s
 * @returns {?number} auf Cent gerundet
 */
export function parseAmount(s) {
    let t = String(s == null ? '' : s).trim();
    if (!t) {
        return null;
    }
    // Zwei Nachkommastellen hinter einem Komma = deutsches Format, sonst ist
    // das Komma ein Tausendertrenner.
    t = /,\d{1,2}$/.test(t) ? t.replace(/\./g, '').replace(',', '.') : t.replace(/,/g, '');
    const v = parseFloat(t);
    return (isFinite(v) && v >= 0) ? Math.round(v * 100) / 100 : null;
}

/** Restzahlung = Bruttobetrag abzüglich Anzahlung, nie negativ. */
export function restAmount(gross, advance) {
    if (advance == null) {
        return null;
    }
    return Math.max(0, Math.round(((gross || 0) - advance) * 100) / 100);
}

/** Anteil der Anzahlung am Bruttobetrag in Prozent (eine Nachkommastelle). */
export function advancePercentOf(gross, advance) {
    if (advance == null || !(gross > 0)) {
        return null;
    }
    return Math.round(advance / gross * 1000) / 10;
}
